import React, { useState } from "react";
import Header from "../../Components/layouts/Header";
import Input from "../../Components/themes/Input";

const Cultivation = () => {
  const [openTab, setOpenTab] = useState('New')
  return (
    <>
      <Header title="Farmer" subtitle="Cultivation" />
      <section>
        <Input />
        <div className="mt-10 flex mx-[6%]">
          <button className={`text-[#F3FFF1] shadow-[0px_4px_3px_rgba(0,0,0,0.25)] w-[6vw] py-1 px-3 rounded mx-5 text-sm font-thin
          ${openTab === 'New' ? 'bg-[#05AB2A]' : 'bg-[#526D4E]'}`} onClick={() => { setOpenTab('New') }}>
            New
          </button>
          <button className={`text-[#F3FFF1] flex justify-center shadow-[0px_4px_3px_rgba(0,0,0,0.25)] w-[6vw] py-1 px-3 rounded mx-5 text-sm font-thin ${openTab === 'Current' ? 'bg-[#05AB2A]' : 'bg-[#526D4E]'}`} onClick={() => { setOpenTab('Current') }}>
            Current
          </button>
          <button className={`text-[#F3FFF1] shadow-[0px_4px_3px_rgba(0,0,0,0.25)] w-[6vw] py-1 px-3 rounded mx-5 text-sm font-thin 
          ${openTab === 'Old' ? 'bg-[#05AB2A]' : 'bg-[#526D4E]'}`} onClick={() => { setOpenTab('Old') }}>
            Old
          </button>
        </div>
        <div className={openTab === 'New' ? "block" : "hidden"}>
          <form className="grid grid-cols-[21%_24%_5%] lg:grid-cols-[28%_33%_5%] xl:grid-cols-[21%_25%_5%] my-5 items-center">
            <label className="ml-20 mr-12 text-[#13490A] font-roboto font-extrabold text-sm">Number of slots</label>
            <input type="text" className="bg-[#F3FFF1] h-8 w-72 lg:w-[96%] shadow-[4px_4px_4px_rgba(0,0,0,0.25)] rounded-md flex-1" />
            <img src="Images/Dropdown.png" alt="dropdown" className="mx-3" />
          </form>
          <table className="table-auto bg-[#6E776D] border-collapse border ml-[21%] w-[54vw] lg:w-[60vw] text-sm font-semibold">
            <thead>
              <tr className="text-[#FFFFFF] h-7 font-medium">
                <th>S.No</th>
                <th>Slot number</th>
                <th>Area</th>
                <th>Type</th>
                <th>Crop</th>
                <th>Variety</th>
                <th>Date of Sowing</th>
                <th>Adopted Season</th>
                <th>Current Stage</th>
              </tr>
            </thead>
            <tbody>
              <tr className="bg-[#DEDEDE] h-7">
                <td className="border-r-4 border-[#6E776D]">01</td>
                <td className="border-r-4 border-[#6E776D]">G01</td>
                <td className="border-r-4 border-[#6E776D]">2 acre</td>
                <td className="border-r-4 border-[#6E776D]">Garden</td>
                <td className="border-r-4 border-[#6E776D]">Maize</td>
                <td className="border-r-4 border-[#6E776D]">ShallMar</td>
                <td className="border-r-4 border-[#6E776D]">07/04/2022</td>
                <td className="border-r-4 border-[#6E776D]">Kharif</td>
                <td>Vegetative</td>
              </tr>
              <tr className="h-7">
                <td className="border-r-4 border-[#6E776D]">02</td>
                <td className="border-r-4 border-[#6E776D]">G02</td>
                <td className="border-r-4 border-[#6E776D]">2 Acre</td>
                <td className="border-r-4 border-[#6E776D]">Garden</td>
                <td className="border-r-4 border-[#6E776D]">Onion</td>
                <td className="border-r-4 border-[#6E776D]">B.Shakti</td>
                <td className="border-r-4 border-[#6E776D]">13/03/2022</td>
                <td className="border-r-4 border-[#6E776D]">Rabi</td>
                <td>Fruiting</td>
              </tr>
              <tr className="bg-[#DEDEDE] h-7">
                <td className="border-r-4 border-[#6E776D]">03</td>
                <td className="border-r-4 border-[#6E776D]">D01</td>
                <td className="border-r-4 border-[#6E776D]">2 acre</td>
                <td className="border-r-4 border-[#6E776D]">Dry</td>
                <td className="border-r-4 border-[#6E776D]">Peas</td>
                <td className="border-r-4 border-[#6E776D]">Sugar</td>
                <td className="border-r-4 border-[#6E776D]">05/04/2022</td>
                <td className="border-r-4 border-[#6E776D]">Kharif</td>
                <td>Vegetative</td>
              </tr>
            </tbody>
          </table>
          <button type="submit"
            className="bg-[#05AB2A] text-[#F3FFF1] flex shadow-[0px_4px_3px_rgba(0,0,0,0.25)] py-1 px-4 rounded mx-60 my-8 text-sm font-thin">
            Submit
          </button>
        </div>
        <div className={openTab === 'Current' ? "block" : "hidden"}>Current Content</div>
        <div className={openTab === 'Old' ? "block" : "hidden"}>Old Content</div>
      </section>
    </>
  );
};

export default Cultivation;
